<template>
  <div>
    <ion-menu class="hamburger-menu"  style="z-index: 999;" side="end" :width="500" :menuInnerEl="`<div class='my_menu-inner'><slot></slot></div>`"
              content-id="routerView" @ionWillOpen="ionWillOpen">
      <ion-content>
        <ul>
          <li class="close-button">
            <img @click="closeHamburger()"
                 src="/assets/common/hamburger-menu/close-button.png"/>
          </li>
          <li class="menu-li is-not-login" v-show="!isLogin">
            <ion-button size="default" fill="outline" @click="goHamburger('/login')">로그인</ion-button>
            <ion-button size="default" fill="solid" @click="goHamburger('/member/join/step2')">회원가입</ion-button>
          </li>
          <li class="menu-li is-login" v-show="isLogin">
            <div class="member-image" @click="goHamburger('/mypage/myinfo')">
              <div>
                <ion-avatar mode="ios">
                  <img v-if="member.profile_image_url === '' || member.profile_image_url === null"
                       src="/assets/common/hamburger-menu/member-image.png">
                  <img v-else :src="member.profile_image_url">
                </ion-avatar>
              </div>
<!--              <div class="member-image-setting" @click="goHamburger('/mypage/myinfo')">-->
<!--                  <img src="/assets/common/hamburger-menu/member-image-setting.png" />-->
<!--              </div>-->
            </div>
            <div class="member-info">
              <tool-tip class="hello mb-2" label="안녕하세요!" :type="'hamburger'" />
              <div class="nickname lbl_bold">{{ member.nickname }}</div>
              <div class="school h-layout align-items-center">
                <span class="lbl_default2" v-if="member.school_div === '10'">{{ $t('lecture.ele_school') }}</span>
                <span class="lbl_default2" v-else-if="member.school_div === '20'">{{ $t('lecture.middle_school') }}</span>
                <span class="lbl_default2">&nbsp;{{ member.school_grade_name }}</span>
                <div class="button ml-2">
                  <ion-button size="small" fill="outline" @click="goHamburgerLogin('/mypage/ticket')">{{ $t('common.hamburger_menu_voucher') }}</ion-button>
                </div>
              </div>

            </div>
          </li>
          <li class="menu-li" @click="isMenuPreview = !isMenuPreview">
            <div class="menu-image">
              <img src="/assets/common/hamburger-menu/menu-preview.png"/>
            </div>
            <div class="menu-text">둘러보기</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-down" v-show="!isMenuPreview"></ion-icon>
              <ion-icon mode="ios" name="arrow-up" v-show="isMenuPreview"></ion-icon>
            </div>
          </li>
          <li class="sub-menu" v-show="isMenuPreview">
            <ul>
              <li class="school-menu" @click="isMenuElementarySchool = !isMenuElementarySchool">
                 <div>교과강의</div>
                                <div>초등</div>
                <div>
                  <ion-icon mode="ios" name="arrow-down" v-show="!isMenuElementarySchool"></ion-icon>
                  <ion-icon mode="ios" name="arrow-up" v-show="isMenuElementarySchool"></ion-icon>
                </div>
              </li>
              <li class="school-sub-menu is-elementary-school" v-show="isMenuElementarySchool">
                <div>
                                    <ion-button size="small"  fill="outline" @click="goSchoolPage('10','01')">초 1</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','02')">초 2</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','03')">초 3</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','04')">초 4</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','05')">초 5</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','06')">초 6</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('00')">전체</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('10')">국어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('11')">영어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('12')">수학</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('13')">사회</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('14')">과학</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('15')">봄~겨울</ion-button>
                                </div>
              </li>
              <li class="school-menu" @click="isMenuMiddleSchool = !isMenuMiddleSchool">
                <div></div>
                <div>중등</div>
                <div>
                  <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMiddleSchool"></ion-icon>
                  <ion-icon mode="ios" name="arrow-up" v-show="isMenuMiddleSchool"></ion-icon>
                </div>
              </li>
              <li class="school-sub-menu is-middle-school" v-show="isMenuMiddleSchool">
                <div>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','01')">중 1</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','02')">중 2</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','03')">중 3</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('00')">전체</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('10')">국어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('11')">영어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('12')">수학</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('13')">사회</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('14')">과학</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('16')">역사</ion-button>
                                </div>
              </li>
             <li @click="goHamburger('/preview/lecture/plan/00')">기획특강</li>
                            <li @click="goHamburger('/preview/teacher')">선생님별</li>
            </ul>
          </li>
          <li class="menu-li" @click="isMenuMyTextbook = !isMenuMyTextbook">
            <div class="menu-image">
              <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/new/ic_menu1.png"/>
            </div>
            <div class="menu-text">My Textbook</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyTextbook"></ion-icon>
              <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyTextbook"></ion-icon>
            </div>
          </li>
          <li class="sub-menu" v-show="isMenuMyTextbook">
            <ul>
              <li @click="goHamburgerLogin('/mytextbook/course/listen')">내가 최근에 들은 강의</li>
                            <li @click="goHamburgerLogin('/mytextbook/playlist')">내 플레이 리스트</li>
                            <li @click="goHamburgerLogin('/mytextbook/course/put')">내가 담은 강의</li>
<!--                            <li @click="goHamburgerLogin('/mytextbook/course/download')">내가 다운로드 한 강의</li>-->
                            <li @click="goHamburgerLogin('/mytextbook/course/interest')">내가 좋아하는 강의</li>
                            <li @click="goHamburgerLogin('/mytextbook/teacher')">내가 좋아하는 선생님</li>
            </ul>
          </li>
          <li class="menu-li" @click="isMenuMyContents = !isMenuMyContents">
            <div class="menu-image">
              <img src="/assets/new/ic_menu2.png" style="height: 22px"/>
            </div>
            <div class="menu-text">참여하기</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyContents"></ion-icon>
              <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyContents"></ion-icon>
            </div>
          </li>
          <li class="sub-menu" v-show="isMenuMyContents">
            <ul>
              <li @click="goHamburgerLogin('/mycontent/register')">내 교과서 만들기</li>
                            <li @click="goHamburgerLogin('/mycontent/mycontent')">내가 참여한 컨텐츠</li>
                            <li @click="goHamburger('/mycontent/best')">내만교 인기 랭킹</li>
                            <li @click="goHamburger('/mycontent/recommended')">추천해주세요</li>
            </ul>
          </li>
          <li class="menu-li" @click="isMenuMyPage = !isMenuMyPage">
            <div class="menu-image">
              <img src="/assets/new/ic_menu3.png" style="height: 22px"/>
            </div>
            <div class="menu-text">My</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyPage"></ion-icon>
              <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyPage"></ion-icon>
            </div>
          </li>
          <li class="sub-menu" v-show="isMenuMyPage">
            <ul>
               <li @click="goHamburger('/mypage/ticket')">이용권 현황</li>
                            <!--<li @click="goHamburgerLogin('/mypage/coupon')">내 쿠폰</li>-->
                            <li @click="goHamburgerLogin('/mypage/myinfo')">내 정보 변경</li>
                            <li @click="goHamburger('/mypage/board')">후기</li>
                            <li @click="goVisitFriend()">친구 초대</li>
                            <li @click="shareListenNote()">포켓튜터 강의노트 공유</li>
                            <li @click="goHamburger('/mypage/cs')">고객센터</li>
            </ul>
          </li>
          <li class="menu-li" @click="goHamburgerLogin('/mypage/push')">
            <div class="menu-image">
              <img src="/assets/new/ic_menu4.png"
                   style="height: 15px !important;"/>
            </div>
            <div class="menu-text">푸시메세지함</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-right"></ion-icon>
            </div>
          </li>
          <li class="menu-li" @click="goHamburgerLogin('/mypage/point_use_history')">
            <div class="menu-image">
              <img src="/assets/new/ic_menu5.png"/>
            </div>
            <div class="menu-text">포인트 사용 내역</div>
            <div class="menu-icon">
              <ion-icon mode="ios" name="arrow-right"></ion-icon>
            </div>
          </li>
          <li class="menu-li">
            <div class="menu-image">
              <img src="/assets/new/ic_menu6.png"/>
            </div>
            <div class="menu-text">소리알림</div>
            <div class="icon">
              <ion-toggle mode="ios" :checked="member.sound_yn" @ionChange="e=> onSettingChange(e,'sound')"></ion-toggle>
            </div>
          </li>
          <li class="menu-li">
            <div class="menu-image">
              <img src="/assets/new/ic_menu7.png"/>
            </div>
            <div class="menu-text">푸쉬알림</div>
            <div class="icon">
              <ion-toggle mode="ios" :checked="member.push_yn" @ionChange="e => onSettingChange(e,'push')"></ion-toggle>
            </div>
          </li>
          <li class="menu-li" @click="goHamburgerLogin('/mypage/setting')">
            <div class="menu-image">
              <img src="/assets/common/hamburger-menu/menu-setting.png"/>
            </div>
            <div class="menu-text">설정</div>
          </li>
          <!--                    <li class="menu-li" @click="goHamburgerLogin('/notice/notice')">-->
          <!--                      <div class="menu-image">-->
          <!--                        <img src="/assets/common/hamburger-menu/menu-setting.png" />-->
          <!--                      </div>-->
          <!--                      <div class="menu-text">Notice</div>-->
          <!--                    </li>-->
          <!--                    <li class="menu-li" @click="goHamburgerLogin('/useful')">-->
          <!--                      <div class="menu-image">-->
          <!--                        <img src="/assets/common/hamburger-menu/menu-setting.png" />-->
          <!--                      </div>-->
          <!--                      <div class="menu-text">Useful</div>-->
          <!--                    </li>-->
          <!--                    <li class="menu-li" @click="goHamburgerLogin('/purchase/reward_list')">-->
          <!--                      <div class="menu-image">-->
          <!--                        <img src="/assets/common/hamburger-menu/menu-setting.png" />-->
          <!--                      </div>-->
          <!--                      <div class="menu-text">Purchase</div>-->
          <!--                    </li>-->
        </ul>
      </ion-content>
    </ion-menu>
    <ion-menu-controller id="routerView"></ion-menu-controller>
  </div>
</template>

<script>
import * as ajax from "../utils/ajax";
import * as alert from '../utils/alert';
import * as biz from "../utils/biz";
import * as utils from "../utils/utils";
import ToolTip from "@/components/ToolTip";

export default {
  name: "Hamburger",
  components: {ToolTip},
  data() {
    return {
      isLogin: false,
      isMenuPreview: false,
      isMenuMyTextbook: false,
      isMenuMyContents: false,
      isMenuMyPage: false,
      isMenuElementarySchool: false,
      isMenuMiddleSchool: false,
      member: {
        nickname: null,
        profile_image_url: null,
        school_div: null,
        school_grade: null,
        school_grade_name: null
      }
    }
  },
  mounted() {
  },
  methods: {
    invokeSoundState(){
      switch(utils.deviceInfo()) {
        case "Android":
          window.listenApp.invokeSoundState(this.$store.state.memberInfo.sound_yn);
          break;
        case "iOS":
          window.webkit.messageHandlers.invokeSoundState.postMessage(this.$store.state.memberInfo.sound_yn);
          break;
      }
    },
    onSettingChange(e, type){
      let state = e.target.checked;
      let params = {}
      switch (type){
        case 'sound':
          params = {
            sound_yn: state ? 'Y' : 'N'
          };
          break;
        case 'push':
          params = {
            push_yn: state ? 'Y' : 'N'
          };
      }
      ajax.Put(this, "/api/member/member/" + type + "_setting", params, function(ref, data) {
        if (data === "success") {
          if(type == 'sound'){
            ref.$store.state.memberInfo.sound_yn = state ? 'Y' : 'N';
            ref.invokeSoundState()
          }
        }
      });
    },
    ionWillOpen() {
      this.isLogin = biz.isLogin(this);
      if (this.isLogin) {
        this.getMemberInfo();
      }
      this.isMenuPreview = false;
      this.isMenuMyTextbook = false;
      this.isMenuMyContents = false;
      this.isMenuMyPage = false;
      this.isMenuElementarySchool = false;
      this.isMenuMiddleSchool = false;
    },
    getMemberInfo() {
      ajax.Get(this, "/api/member/member/", function (ref, data) {
        if (data.nickname === null || data.nickname === "")
          data.nickname = data.member_name;

        ref.member.nickname = data.nickname;
        ref.member.profile_image_url = data.profile_image_url;
        ref.member.school_div = data.school_div;
        ref.member.school_grade = data.school_grade;
        ref.member.school_grade_name = data.school_grade_name;
        ref.member.sound_yn = data.sound_yn == 'Y';
        ref.member.push_yn = data.push_yn == 'Y';
      });
    },
    openHamburger() {
      this.$store.state.enableHamburgerMenu = true;
      document.querySelector('ion-menu-controller').open();
    },
    closeHamburger() {
      document.querySelector('ion-menu-controller').close();
      this.$store.state.enableHamburgerMenu = false;
    },
    goHamburger(url) {
      this.$router.push(url);
      document.querySelector('ion-menu-controller').close();
    },
    goHamburgerLogin(url) {
      if (!this.isLogin) {
        alert.alertLogin(this);
      } else {
        this.$router.push(url);
      }
      document.querySelector('ion-menu-controller').close();
    },
    goSchoolPage(school, grade) {
      this.$cookie.set("tempSchoolDiv", school);
      this.$cookie.set("tempSchoolGrade", grade);

      const today = new Date();
      this.$router.push({path: '/preview/lecture/subject/00', query: {key: today.toISOString()}});

      document.querySelector('ion-menu-controller').close();
    },
    goLecturePage(subject) {
      const today = new Date();
      this.$router.push({path: '/preview/lecture/subject/' + subject, query: {key: today.toISOString()}});

      document.querySelector('ion-menu-controller').close();
    },
    goVisitFriend() {
      if (!this.isLogin) {
        alert.alertLogin(this);
      } else {
        const message = this.member.member_name + " invited  to the listenning textbook!\n" +
            "A textbook that can listen to without any burden, listen to it with your friends~\n" +
            "http://textbooklistening.com";

        switch (utils.deviceInfo()) {
          case "Android":
            window.listenApp.invokeShare(message);
            break;
          case "iOS":
            window.webkit.messageHandlers.invokeShare.postMessage(message);
            break;
        }
      }
    },
    shareListenNote() {
      if (!this.isLogin) {
        alert.alertLogin(this);
      } else {
        const message = "Use 'handwritten notes' for listening textbooks and use them for learning~\n" +
            "https://ba8hb5guu4.ecn.cdn.ofs.kr/doc/listen_note.pdf";

        switch (utils.deviceInfo()) {
          case "Android":
            window.listenApp.invokeShare(message);
            break;
          case "iOS":
            window.webkit.messageHandlers.invokeShare.postMessage(message);
            break;
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.my_menu-inner {
  height: 90%;
  border-bottom-left-radius: 20px;
  width: 70%;
}
ul {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;

  li.menu-li {
    width: 100%;
    height: 50px;
    margin: 0 0 1px 0;
    padding: 0 20px 0 30px;
    display: flex;
    align-items: center;
    //justify-content: space-between;
    background-color: $line-third-color;
    line-height: 50px;
    font-weight: 500;


    div.menu-text {
      //width: 80px;
    }

    div.menu-image {
      //flex: 1;
      img {
        margin-right: 15px;
        height: 18px;
        vertical-align: sub;
      }
    }

    div.menu-icon {
      margin-left: auto;
      width: 16px;
      color: $font-fourth-color;

      ion-icon[name=arrow-up] {
        color: #ff6c00;
      }

      ion-icon[name=arrow-right] {
        color: #ff6c00;
        background-image: url("/assets/new/ic_arrow_right1.png");
        background-size: 100% 100%;
        width: 9px;
        height: 12px;
      }
    }

    div.icon {
      margin-top: 16px;
      margin-left: auto;
    }
  }

  li.close-button {
    height: 18px;
    padding: 10px 10px 0 10px;
    text-align: right;

    img {
      height: 18px;
    }
  }

  li.is-not-login {
    height: 135px;
    padding: 40px 40px;
    background-color: #ffffff;

    ion-button {
      width: 91px;
    }
  }

  li.is-login {
    height: 135px;
    padding: 10px 10px 0 10px;
    display: flex;
    //justify-content: center;
    background-color: #ffffff;

    div.member-image {
      margin: 0 20px 0 8px;
      padding: 20px 0 0 0;
      text-align: center;

      div.member-image-setting {
        img {
          height: 20px;
          vertical-align: super;
        }
      }
    }

    div.member-info {
      //text-align: center;

      div.school {
        line-height: 20px;
        color: $font-third-color;
        display: flex;
        font-weight: bold;
      }
      div.nickname {
        font-size: 14px;
        line-height: 15px ;
        color: $font-sixth-color;
      }

      div.button {
        ion-button {
          font-size: 8px;
          color: $font-sixth-color;
          --border-radius: 15px;
          --border-color: #ff7e15;
          --color-activated: none;
          --color-focused: none;
          --color-hover: none;
          --background-activated: none;
          --background-focused: none;
          --background-hover: none;
        }
      }
    }
  }

  li.sub-menu {
    background-color: #ffffff;

    & > ul {
      li {
        width: 100%;
        height: 40px;
        margin: 0;
        padding: 0 15px;
        border-bottom: 1px solid $line-third-color;
        line-height: 40px;
        font-size: $font-base14;
        font-weight: 400;
        color: $font-third-color;
      }

      li.school-menu {
        display: flex;
        justify-content: flex-start;

        div {
          ion-icon[name=arrow-down] {
            color: $line-secondary-color;
          }

          ion-icon[name=arrow-up] {
            color: #ff6c00;
          }
        }

        div:nth-child(1) {
          width: 75px;
        }

        div:nth-child(2) {
          width: 40px;
        }
      }

      li.school-sub-menu {
        height: auto;
        text-align: right;

        & > div {
          height: 32px;
        }

        ion-button {
          width: 62px;
          color: $font-third-color;
          --border-color: #d4d4d4;
          --color-activated: none;
          --color-focused: none;
          --color-hover: none;
          --background-activated: none;
          --background-focused: none;
          --background-hover: none;
        }
      }

      li.school-sub-menu.is-elementary-school {
        height: 148px;
      }

      li.school-sub-menu.is-middle-school {
        height: 118px;
      }
    }
  }
}
</style>